import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../app/hooks/store-hooks';
import { useMapSourceSettings } from '../../../app/hooks/use-map-settings';
import { NavMapModel } from '../../../app/state/slices/global-slice';
import { setSetting } from '../../../app/state/slices/settings-slice';
import { DateTimeFormatter } from '../../../formatters';
import { CheckmarkOutline } from '../../../icons/icons';
import { MenuItem } from '../../common/menu/DropdownMenu';

export function MapNavSettingsContextMenu() {
    const mapSource = useMapSourceSettings();
    const mapSourceOptions = useAppSelector((x) => x.global.mapSettings.navSources);
    const dispatch = useDispatch();
    const nav = mapSource.nav;
    const selectedOption = mapSourceOptions.find((x) => equal(x, nav));

    const handleSelect = (e: NavMapModel) => {
        if (e === selectedOption) {
            return;
        }

        dispatch(
            setSetting('navMap', {
                company: e.company,
                version: e.version,
                sequence: e.sequence,
                cycleDate: dayjs.unix(e.cycleDate).toISOString(),
                buildDate: dayjs.unix(e.buildDate).toISOString()
            })
        );
    };

    return (
        <>
            {mapSourceOptions.map((x, i) => {
                return (
                    <MenuItem
                        key={i}
                        onClick={() => handleSelect(x)}
                        icon={x === selectedOption ? CheckmarkOutline : undefined}
                        labelElement={
                            <>
                                <div className="d-flex align-items-center gap-2">
                                    Cycle date: {DateTimeFormatter.formatDate(x.cycleDate)}, Build date:{' '}
                                    {DateTimeFormatter.formatDateTime(x.buildDate)}
                                </div>
                            </>
                        }></MenuItem>
                );
            })}
        </>
    );
}

function equal(a: NavMapModel, b: NavMapModel): boolean {
    return (
        a.company === b.company &&
        a.buildDate === b.buildDate &&
        a.version === b.version &&
        a.sequence === b.sequence &&
        a.cycleDate === b.cycleDate
    );
}
